import React from "react";
import { VscSettingsGear } from "react-icons/vsc";
import ProjectCards from "./ProjectCards";

const Projects = () => {
  return (
    <div
      className="text-[#FFFFFF] p-6 text-center font-serif mt-[50px] lg:mt-[150px] "
      id="projects"
    >
      <div className="text-2xl  flex items-center justify-center gap-1 rounded pt-8  font-bold">
        <div className="text-[#E84949] flex w-[24px] top-[4.28%] left-0 bottom-[4%] right-0 font-bold">
          <VscSettingsGear />
          <VscSettingsGear size={20} className="h-[-10px] w-[10px] mt-1" />
        </div>
        <h1 className="text-[#E84949]"> Projects</h1>
      </div>

      {/* PROJECTS CARDS */}
      <ProjectCards />
    </div>
  );
};

export default Projects;
